import angular from 'angular';
import constants from 'app/constants';
import {
  amDataService,
  loaderService,
  ssDialogService,
  userService,
} from 'app/services';
import {
  alerts,
  confirmDialog,
} from 'app/components/global';
import controller from './finding-report.controller';
import directive from './finding-report.directive';


export default angular.module('app.components.advisory.auditTrail.findingReport', [
  alerts,
  amDataService,
  confirmDialog,
  constants,
  loaderService,
  ssDialogService,
  userService,
])
  .directive('amFindingReport', directive)
  .controller('FindingReportController', controller)
  .name;

console.log('app.components.advisory.auditTrail.findingReport created');
